import script from "./bonusomat-spin-winner.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusomat-spin-winner.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__